import { FactsItem } from '../facts-card/facts-card.model';
import eye from '../../../../../assets/images/facts/eye.png';
import eyeColor from '../../../../../assets/images/facts/eye-color.png';
import color from '../../../../../assets/images/facts/color.png';
import eagle from '../../../../../assets/images/facts/eagle.png';
import iris from '../../../../../assets/images/facts/iris.png';
import book from '../../../../../assets/images/facts/book.png';
import table from '../../../../../assets/images/facts/table.png';
import painting from '../../../../../assets/images/facts/painting.png';
import devices from '../../../../../assets/images/facts/devices.png';
import tears from '../../../../../assets/images/facts/tears.png';
import eyeDark from '../../../../../assets/images/facts/eye-dark.png';
import eyes from '../../../../../assets/images/facts/eyes.png';

export const items1Left: FactsItem[] = [
  {
    title: 'facts.title-7',
    content: ['facts.content-14'],
    icon: eyeColor,
    isReverse: true,
  },
  {
    title: 'facts.title-12',
    content: ['facts.content-24'],
    icon: color,
    isReverse: true,
  },
];
export const items1Right: FactsItem[] = [
  {
    title: 'facts.title-8',
    content: ['facts.content-15', 'facts.content-16'],
    icon: iris,
    isReverse: true,
  },
  {
    title: 'facts.title-1',
    content: ['facts.content-1', 'facts.content-2'],
    icon: eye,
    isReverse: true,
  },
];
export const items2Top: FactsItem[] = [
  {
    title: 'facts.title-4',
    content: ['facts.content-7', 'facts.content-8', 'facts.content-9'],
    icon: eagle,
    isRow: true,
  },
];
export const items2Bottom: FactsItem[] = [
  {
    title: 'facts.title-2',
    content: ['facts.content-3', 'facts.content-4'],
    icon: painting,
    isReverse: true,
    isWide: true,
  },
  {
    title: 'facts.title-3',
    content: ['facts.content-5', 'facts.content-6'],
    icon: eyeDark,
    isNarrow: true,
  },
];
export const items3Top: FactsItem[] = [
  {
    title: 'facts.title-11',
    content: ['facts.content-20'],
    list: ['facts.content-21', 'facts.content-22', 'facts.content-23'],
    icon: tears,
    isReverse: true,
    isNarrow: true,
  },
  {
    title: 'facts.title-5',
    content: ['facts.content-10', 'facts.content-11'],
    icon: eyes,
    isWide: true,
  },
];
export const items3Bottom: FactsItem[] = [
  {
    title: 'facts.title-6',
    content: ['facts.content-12', 'facts.content-13'],
    icon: devices,
    isRowReverse: true,
  },
];
export const items4: FactsItem[] = [
  {
    title: 'facts.title-9',
    content: ['facts.content-17', 'facts.content-18'],
    icon: table,
    isReverse: true,
    isWide: true,
  },
  {
    title: 'facts.title-10',
    content: ['facts.content-19'],
    icon: book,
    isNarrow: true,
    isSmallMobile: true,
  },
];

export const notes = [
  'facts.note-1', 'facts.note-2', 'facts.note-3', 'facts.note-4', 'facts.note-5', 'facts.note-6',
  'facts.note-7', 'facts.note-8', 'facts.note-9', 'facts.note-10', 'facts.note-11', 'facts.note-12',
  'facts.note-13', 'facts.note-14', 'facts.note-15', 'facts.note-16', 'facts.note-17', 'facts.note-18',
  'facts.note-19',
];
